import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import alasql from 'alasql'
import _ from 'lodash'

import Pie from '../../helper/piechart.helper'
import HomeChart from '../../helper/homechart.helper'
import DataTable from '../../helper/datatable.helper'

import BacktestService from '../../service/backtest.service'

import Button from '../parts/Button'

class Live extends Component {

	tables = {
		portfolioDataTable: null,
		monthly: null,
		annualize: null,
		calendar: null,
		holding: null,
		staticstic: null,
		years: null,
		portfolios_compare: null
	}

	state = {
		pies: [],
		widgetAlphas: {
			beta: 0,
			alpha: 0,
			sortino_ratio: 0,
			sharpe: 0,
		},

		perfCharts: {
			first: [],
			all: []
		},

		scenarios: [],
		scenario_id: 0,
		scenario_name: '',

		portfolioFilter: [],
		portfolioData: {},
		selectedPortfolioDate: '',

		benchmark: '',

		loading: false,
		backtest: {},

		blocks: {
			main_chart_place: true,
			fund_benchmark_comparison_place: true,
			conservative_fund_chart_place: true,
			widgetAlphas: true,
			annualized_back_place: true,
			monthly_return_table: true,
			asset_class_stock_place: true,
			holdings_tbl_place: true,
		},

		last: {
			a: 0,
			b: 0,
		},

		port_info: {
			port_min_dt: null,
			port_max_dt: null,
			bm_min_dt: null,
			bm_max_dt: null,
			fund_name: null,
			bm_name: null,
		},

		performance: [],
	}

	componentDidMount() {

		this.props.loadStart()

		BacktestService.getLivePortfolios()
			.then(scenarios => {
				if(scenarios) {
					this.setState({ scenarios })
					this.loadBacktest()
				}
			})
	}

	componentWillMount() {
		this.props.setPath(['Live'])
	}

	setScenario(e) {

		const scenario = alasql("SELECT DISTINCT scenario_name FROM ? WHERE scenario_id = "+e.target.value+"", [this.state.scenarios])
		if(scenario.length)
			this.state.scenario_name = scenario[0].scenario_name

		this.state[e.target.name] = e.target.value
		this.setState(this.state)
	}

	async loadBacktest(e) {

		this.setState({ loading: true })

		let scenario_id = 0;

		if(e) {
			scenario_id = this.state.scenario_id
			e.preventDefault()
		}
		else {
			scenario_id = this.state.scenarios[0].scenario_id
			let scenario_name = this.state.scenarios[0].scenario_name
			this.setState({ scenario_id, scenario_name })
		}

		for(let i in this.tables) {
			if(!this.tables[i])continue;

			this.tables[i].destroy()
			this.tables[i] = null
		}

		await BacktestService.getBacktest(scenario_id, 'BM_60_40', 'LIVE')
			.then(this.renderPageData.bind(this))
        
		await BacktestService.getBacktest(scenario_id, 'BM_60_40', 'CURRENT')
			.then(this.renderComparePortfolioTables.bind(this))
        
		await BacktestService.getPerfHistMetrics(scenario_id, 'LIVE')
			.then(res => {
				if(res) {
					this.renderMonthlyTable(res)
					this.renderYearsCharts(res)
				}
			})

		await BacktestService.getRiskStatistics(scenario_id, 'LIVE')
			.then(this.renderRiskStatistics.bind(this))

		this.setState({ loading: false })

		this.props.loadStop()
	}

	renderPageData(backtest) {
		if(backtest) {
			this.setState({ backtest })
			this.renderPies()
			this.renderWidgetAlphas()

			if(backtest.getBenchmarkVami.length) {
				this.state.benchmark = backtest.getBenchmarkVami[0].benchmark_name
			}

			if(this.state.backtest.getBenchmarkVami.length) {
				this.state.blocks.main_chart_place = true
				this.setState(this.state)

				let vamix = this.state.backtest.getBenchmarkVami.concat(this.state.backtest.getPortfolioVami)
				HomeChart.renderMainChart('#main_chart_place', vamix)
			}
			else
				this.state.blocks.main_chart_place = false

			if(this.state.backtest.getPortfolioMetrics.length) {
				this.state.blocks.fund_benchmark_comparison_place = true
				this.setState(this.state)
				
				HomeChart.renderFBCChart('#fund_benchmark_comparison_place', this.state.backtest.getPortfolioMetrics)
			}
			else
				this.state.blocks.fund_benchmark_comparison_place = false

			if(this.state.backtest.getMetricsForRange.length) {
				HomeChart.renderConservativeFundChart('#conservative_fund_chart_place', this.state.backtest.getMetricsForRange)
				HomeChart.renderConservativeReturnChart('#conservative_return_chart_place', this.state.backtest.getMetricsForRange)
			}
			else
				this.state.blocks.conservative_fund_chart_place = false

			this.setState(this.state)

			this.renderAssetStylePieChart()

			this.renderPortfolioTable()
		}
	}

	renderPies() {
		this.state.pies = HomeChart.renderPieChart(this.state.backtest.getPortfolioVami, this.state.backtest.getBenchmarkVami, this.state.backtest.getPortfolioMetrics);
		this.setState(this.state);
		
		Pie.renderPies('.easy-pie-chart .number')
	}

	renderWidgetAlphas() {

		if(this.state.backtest.getPortfolioMetrics.length) {

			this.state.blocks.widgetAlphas = true
			this.setState(this.state)

			this.state.widgetAlphas = {
				beta: this.state.backtest.getPortfolioMetrics[0].beta,
				alpha: this.state.backtest.getPortfolioMetrics[0].alpha,
				sortino_ratio: this.state.backtest.getPortfolioMetrics[0].sortino_ratio,
				sharpe: this.state.backtest.getPortfolioMetrics[0].sharpe,
			}

			this.setState(this.state)

			Pie.renderCounterUp()
		}
		else {
			this.state.blocks.widgetAlphas = false
			this.setState(this.state)
		}

	}

	renderPortfolioTable() {

		this.state.portfolioData = {}
		this.state.portfolioFilter = []

		for(let i in this.state.backtest.getPortfolioData) {
			let line = this.state.backtest.getPortfolioData[i];

			i == 0 ? this.state.selectedPortfolioDate = line.dt : null;

			if(i == 0 || (this.state.portfolioFilter[this.state.portfolioFilter.length - 1] && this.state.portfolioFilter[this.state.portfolioFilter.length - 1].value != line.dt)) {
				this.state.portfolioFilter.push({
					value: line.dt
				})
			}

			(line.dt in this.state.portfolioData) ? this.state.portfolioData[line.dt].push([
				line.symbol, line.fund_name, line.fund_asset_class_focus, line.allocation
			]) : this.state.portfolioData[line.dt] = [[line.symbol, line.fund_name, line.fund_asset_class_focus, line.allocation]];

		}

		this.setState(this.state);

		let cols = [
			{ title: 'Symbol' },
			{ title: 'Name' },
			{ title: 'Asset Class' },
			{ title: 'Weight(%)' },
		]

		this.tables.portfolioDataTable = (Object.keys(this.state.portfolioData).length) ? new DataTable('#portfolio_data_place', cols, this.state.portfolioData[this.state.selectedPortfolioDate], true) : {}
	}

	changePortfolioDate(e) {
		this.setState({ selectedPortfolioDate: e.target.value })
		let newData = this.state.portfolioData[e.target.value]
		this.tables.portfolioDataTable.rerender(newData, ['Symbol', 'Name', 'Asset Class', 'Weight(%)'])
	}

	renderMonthlyTable(data) {
		if(data.length) {

			this.state.blocks.monthly_return_table = true
			this.setState(this.state)

			let cols = [
				{ "title": "Year" },
				{ "title": "" },
				{ "title": "Jan" },
				{ "title": "Feb" },
				{ "title": "Mar" },
				{ "title": "Apr" },
				{ "title": "May" },
				{ "title": "Jun" },
				{ "title": "Jul" },
				{ "title": "Aug" },
				{ "title": "Sep" },
				{ "title": "Oct" },
				{ "title": "Nov" },
				{ "title": "Dec" },
				{ "title": "YTD" }
			];

			let rows = [];

			for(let i in data) {
				let line = data[i]

				if(line.metric_name.length != 4 || (line.metric_name.length == 4 && !moment(line.metric_name, 'YYYY').isValid()))continue;

				let row = [line.metric_name, '']
				let portfolio = ['', 'Portfolio']
				let benchmark = ['', 'Benchmark']

				for(let i = 1; i <= 12; i++) {
					const date = moment(i + '-' +line.metric_name, 'M-YYYY').format('MM-YYYY')
					const res = alasql("select * from ? where metric_name = '" + date + "'", [data])
					
					if(!res.length) {
						row.push('')
						portfolio.push('')
						benchmark.push('')
					}
					else {
						row.push("")
						portfolio.push((parseFloat(res[0].fund_return)*100).toFixed(2) + '%')
						benchmark.push((parseFloat(res[0].bm_return)*100).toFixed(2) + '%')
					}
				}

				const ytd = alasql("select * from ? where metric_name = '" + line.metric_name + "'", [data])

				if(!ytd.length) {
					row.push('')
					portfolio.push('')
					benchmark.push('')
				}
				else {
					row.push("")
					portfolio.push((parseFloat(ytd[0].fund_return)*100).toFixed(2) + '%')
					benchmark.push((parseFloat(ytd[0].bm_return)*100).toFixed(2) + '%')
				}

				rows.push(row, portfolio, benchmark)

			}

			this.tables.monthly = (this.state.backtest.getPortfolioVami.length) ? new DataTable('#monthly_return_table', cols, rows, false, false) : null
		}
		else {
			this.state.blocks.monthly_return_table = false
			this.setState(this.state)
		}


	}

	renderYearsCharts(data) {

		let homechartportinfo = HomeChart.getPortfolioInfo(this.state.backtest.getPortfolioVami, this.state.backtest.getBenchmarkVami)

		this.state.port_info = {
			port_min_dt: homechartportinfo.port_min_dt || 0,
			port_max_dt: homechartportinfo.port_max_dt || 0,
			bm_min_dt: homechartportinfo.bm_min_dt || 0,
			bm_max_dt: homechartportinfo.bm_max_dt || 0,
			fund_name: homechartportinfo.fund_name || 0,
			bm_name: homechartportinfo.bm_name || 0,
		}

		if(data.length) {

			this.state.blocks.annualized_back_place = true
			this.setState(this.state)

			let performance = HomeChart.renderPerformance(data)
			let annualize = HomeChart.renderAnnualizedBacktestChart('#annualized_back_place', data)
			let calendar = HomeChart.renderCalendarBacktestChart('#calendar_year_place', data)

			HomeChart.renderPerformanceGraph('#performance_graph', data)

			this.tables.years = new DataTable('#performance_table', performance[0], performance[1], false, false)

			this.tables.annualize = new DataTable('#annualized_back_tbl_place', annualize.cats, [annualize.fund_data, annualize.bm_data])
			this.tables.calendar = new DataTable('#calendar_year_tbl_place', calendar.cats, [calendar.fund_data, calendar.bm_data])

		}
		else {
			this.state.blocks.annualized_back_place = false
			this.setState(this.state)
		}

	}

	renderAssetStylePieChart() {
		let holdings = HomeChart.renderAssetStyleStockChart('#asset_class_stock_place', '#style_stock_place', '#asset_class_pie_place', '#style_pie_place', this.state.backtest)
		if(holdings.styles.length) {
			let cols = [
				{ title: 'Name', sTitle: 'Name' },
				{ title: 'Weight', sTitle: 'Weight', width: '80px' },
			]
			this.tables.holding = new DataTable('#holdings_tbl_place', cols, holdings.styles)

			this.state.last = {
				a: holdings.lastA,
				b: holdings.lastB,
			}

			this.state.blocks.holdings_tbl_place = true
		}
		else
			this.state.blocks.holdings_tbl_place = false
		this.setState(this.state)

	}

	renderRiskStatistics(data) {
		if(data) {

			const table_data = HomeChart.renderRiskStatistics(data)

			this.tables.staticstic = new DataTable('#risk_statistics_tbl_place', ...table_data)
		}
	}

	renderComparePortfolioTables(current) {
		if(current) {

			let cols = HomeChart.renderComparePortfolioTables(this.state.backtest.getPortfolioData, current.getPortfolioData)

			let rows = [
				{ title: 'Asset Class' },
				{ title: 'Symbol' },
				{ title: cols.liveDate },
				{ title: cols.currDate },
			]

			this.tables.portfolios_compare = new DataTable('#last_portfolio_compare_table', rows, cols.cols)
            
            
		}
	}

	render() {
		return (
		
			<div className="page-content">
				<div className="head-section">
					<h1 className="text-uppercase">Live</h1>
				</div>

				<div className="form-group">
					<form onSubmit={this.loadBacktest.bind(this)}>
						<div className="row">
							<div className="col-md-2 col-sm-4 col-xs-12">
								<select onChange={this.setScenario.bind(this)} value={this.state.scenario_id} name="scenario_id" className="form-control">
									<option value="">Select</option>
									{this.state.scenarios.map((v, k) =>
										<option value={v.scenario_id} key={k}>{v.scenario_name}</option>
									)}
								</select>
							</div>
							<div className="col-md-2 col-sm-4 col-xs-12">
								<Button className="btn btn-primary" submit={this.loadBacktest.bind(this)} show={this.state.loading}>Get Live Results</Button>
							</div>
						</div>
					</form>
				</div>
				<h4 className="header">{this.state.benchmark}</h4>
				<br />

				{ this.state.blocks.annualized_back_place ?
					<div className="row">
						<div className="col-md-6">
	                        <div className="portlet light bordered">
							    <div className="portlet-title">
							        <div className="caption">
							            <i className="icon-cursor font-dark hide"></i>
							            <span className="caption-subject font-dark bold uppercase">Performance as of {this.state.port_info.port_max_dt} </span>
							        </div>
							    </div>
							    <div className="portlet-body">
							        <div className="row">
							            <div className="col-md-12 col-sm-12 col-xs-12">
						                    <table style={{width: '100%', height: '170px'}} className="table table-striped table-hover table-checkable order-column" id="performance_table"></table>
						                    <div><small><b>*</b> 1 Month is calculated using last 30 day (calendar) returns</small></div>
						                    <div><small><b>**</b> 3 Month is calculated using last 90 day (calendar) returns</small></div>
							            </div>
							        </div>
							    </div>
							</div>
						</div>
						<div className="col-md-6">
	                        <div className="portlet light bordered">
							    <div className="portlet-title">
							        <div className="caption">
							            <i className="icon-cursor font-dark hide"></i>
							            <span className="caption-subject font-dark bold uppercase">Performance as of {this.state.port_info.port_max_dt} </span>
							        </div>
							    </div>
							    <div className="portlet-body">
							        <div className="row">
							        	<div className="col-md-12 col-sm-12 col-xs-12">
						                    <div id="performance_graph" style={{width: '100%', height: '250px'}}></div>
							            </div>
							        </div>
							    </div>
							</div>
						</div>
					</div>
				: null }
            
            	{ this.state.blocks.monthly_return_table ?
					<div className="portlet light bordered">
					    <div className="portlet-title">
					        <div className="caption">
					            <i className="icon-cursor font-dark hide"></i>
					            <span className="caption-subject font-dark bold uppercase">Monthly Returns</span>
					        </div>
					    </div>
					    <div className="portlet-body">
					        <div className="row">
					            <div className="col-md-12 col-sm-12 col-xs-12">
				                    <table className="table table-striped table-hover table-checkable order-column" id="monthly_return_table"></table>
					            </div>
					        </div>
					    </div>
					</div>
				: null }

				{ this.state.blocks.main_chart_place ?
					<div className="row">
						<div className="col-md-8">
							<div className="portlet light bordered">
								<div className="portlet-title">
									<div className="caption">
										<i className="icon-cursor font-dark hide"></i>
										<span className="caption-subject font-dark bold uppercase">CHART</span>
									</div>
								</div>
								<div className="portlet-body">
									<div id="main_chart_place" style={{ width:'100%', height:'400px' }}></div>
								</div>
							</div>
						</div>

						<div className="col-md-4">
							<div className="portlet light bordered">
								<div className="portlet-title">
									<div className="caption">
										<i className="icon-cursor font-dark hide"></i>
										<span className="caption-subject font-dark bold uppercase">FUND AND BENCHMARK COMPARISON</span>
									</div>
								</div>
								<div className="portlet-body">
									<div id="fund_benchmark_comparison_place" style={{ width:'100%', height:'400px' }}></div>
								</div>
							</div>
						</div>
					</div>
				: null }

				<div className="portlet light bordered">
				    <div className="portlet-title">
				        <div className="caption">
				            <i className="icon-cursor font-dark hide"></i>
				            <span className="caption-subject font-dark bold uppercase">PORTFOLIO DATA</span>
				        </div>
				    </div>
				    <div className="portlet-body">
				        <div className="row">
				            <div className="col-md-2 col-sm-4 col-xs-12">
				                <div className="form-group">
				                    <select onChange={this.changePortfolioDate.bind(this)} className="form-control">
				                    	{this.state.portfolioFilter.map((o, i) =>
				                        	<option key={i}>{ o.value }</option>
				                    	)}
				                    </select>
				                </div>
				            </div>
				            <div className="col-md-12 col-sm-12 col-xs-12">
			                    <table className="table table-striped table-hover table-checkable order-column" id="portfolio_data_place"></table>
				            </div>
				        </div>
				    </div>
				</div>

				{/*this.state.blocks.annualized_back_place ? 
					<div className="row">
						<div className="col-md-6">
							<div className="portlet light bordered">
								<div className="portlet-title">
									<div className="caption">
										<i className="icon-cursor font-dark hide"></i>
										<span className="caption-subject font-dark bold uppercase">Annualized Performance</span>
									</div>
								</div>
								<div className="portlet-body">
									<div id="annualized_back_place" style={{ width:'100%', height:'400px' }}></div>

									
										<table className="table table-striped table-hover table-checkable order-column" id="annualized_back_tbl_place"></table>
									
									<br />
									<div><small>* Benchmark comprised of 60% ACWI ETF and 40% AGG ETF; LIVE start date is 12/31/2007</small></div>
								</div>
							</div>
						</div>

						<div className="col-md-6">
							<div className="portlet light bordered">
								<div className="portlet-title">
									<div className="caption">
										<i className="icon-cursor font-dark hide"></i>
										<span className="caption-subject font-dark bold uppercase">Calendar Year Performance</span>
									</div>
								</div>
								<div className="portlet-body">
									<div id="calendar_year_place" style={{ width:'100%', height:'400px' }}></div>
								</div>
								
									<table className="table table-striped table-hover table-checkable order-column" id="calendar_year_tbl_place"></table>
								
								<br />
								<div><small>* Benchmark comprised of 60% ACWI ETF and 40% AGG ETF; LIVE start date is 12/31/2007</small></div>
							</div>
						</div>

					</div>
				: null*/}

				<div className="portlet light bordered">
				    <div className="portlet-title">
				        <div className="caption">
				            <i className="icon-cursor font-dark hide"></i>
				            <span className="caption-subject font-dark bold uppercase">LIVE Asset Class Exposures (AS OF DATE {this.state.last.a})</span>
				        </div>
				    </div>
				    <div className="portlet-body">
				    	<div className="row">
				    		<div className="col-md-6">
				    			<div id="asset_class_pie_place"></div>
				    		</div>
				    		<div className="col-md-6">
								<h3 className="text-right">Intelligent Risk</h3>
								<p>
									Market risk and volatility need to be managed intelligently, now more than ever.
									At IQCIO we use a disciplined, multi-faceted quantitative algorithm that our team developed to determine when the Moderate Model Portfolio should reduce risk.
								</p>
								<br />
								<h3 className="text-right">Intelligent Income</h3>
								<p>
									Searching for investment income today is hard.
									IQCIO takes an intelligent, risk averse approach to generating cash flow suitable for the risk profile of the Income Portfolio.
								</p>
								<br />
								<h3 className="text-right">Intelligent Portfolio</h3>
								<p>
									Selection IQCIO’s powerful technology scours the investable universe of fund opportunities and selects those that allow the Portfolio to meet its goals more predictably.
								</p>
				    		</div>
				    	</div>
				    </div>
				</div>

				<div className="row">
					<div className="col-md-6">
						<div className="portlet light bordered">
						    <div className="portlet-title">
						        <div className="caption">
						            <i className="icon-cursor font-dark hide"></i>
						            <span className="caption-subject font-dark bold uppercase">LIVE Style Exposures (AS OF DATE {this.state.last.a})</span>
						        </div>
						    </div>
						    <div className="portlet-body">
				    			<div id="style_pie_place" style={{width: '100%', height: '450px'}}></div>
				    		</div>
				    	</div>
				    </div>
		    		<div className="col-md-6">
						<div className="portlet light bordered">
						    <div className="portlet-title">
						        <div className="caption">
						            <i className="icon-cursor font-dark hide"></i>
						            <span className="caption-subject font-dark bold uppercase">LIVE Holdings (AS OF DATE {this.state.last.a})</span>
						        </div>
						    </div>
						    <div className="portlet-body">
								
									<table className="table table-striped table-hover table-checkable order-column" id="holdings_tbl_place"></table>
								
						    </div>
						</div>
					</div>
				</div>

				
				<div className="portlet light bordered">
				    <div className="portlet-title">
				        <div className="caption">
				            <i className="icon-cursor font-dark hide"></i>
				            <span className="caption-subject font-dark bold uppercase">RISK STATISTICS</span>
				            <span><i>(Since LIVE start date: {this.state.port_info.port_max_dt})</i></span>
				        </div>
				    </div>
				    <div className="portlet-body">
						
							<table className="table table-striped table-hover table-checkable order-column" id="risk_statistics_tbl_place"></table>
						
						<div><small>{this.state.benchmark}</small></div>
					</div>
				</div>

				{this.state.blocks.widgetAlphas ?
					<div className="row widget-row">
					    <div className="col-md-3">
					        <div className="widget-thumb widget-bg-color-white text-uppercase margin-bottom-20 bordered">
					            <h4 className="widget-thumb-heading">Beta</h4>
					            <div className="widget-thumb-wrap">
					                <i className="widget-thumb-icon bg-green icon-bar-chart"></i>
					                <div className="widget-thumb-body">
					                    <span className="widget-thumb-subtitle">&nbsp;</span>
					                    <span className="widget-thumb-body-stat" data-counter="counterup" data-value={ this.state.widgetAlphas.beta }>0</span>
					                </div>
					            </div>
					        </div>
					    </div>
					    <div className="col-md-3">
					        <div className="widget-thumb widget-bg-color-white text-uppercase margin-bottom-20 bordered">
					            <h4 className="widget-thumb-heading">Alpha</h4>
					            <div className="widget-thumb-wrap">
					                <i className="widget-thumb-icon bg-red icon-bar-chart"></i>
					                <div className="widget-thumb-body">
					                    <span className="widget-thumb-subtitle">&nbsp;</span>
					                    <span className="widget-thumb-body-stat" data-counter="counterup" data-value={ this.state.widgetAlphas.alpha }>0</span>
					                </div>
					            </div>
					        </div>
					    </div>
					    <div className="col-md-3">
					        <div className="widget-thumb widget-bg-color-white text-uppercase margin-bottom-20 bordered">
					            <h4 className="widget-thumb-heading">SORTINO RATIO</h4>
					            <div className="widget-thumb-wrap">
					                <i className="widget-thumb-icon bg-purple icon-bar-chart"></i>
					                <div className="widget-thumb-body">
					                    <span className="widget-thumb-subtitle">%</span>
					                    <span className="widget-thumb-body-stat" data-counter="counterup" data-value={ this.state.widgetAlphas.sortino_ratio }>0</span>
					                </div>
					            </div>
					        </div>
					    </div>
					    <div className="col-md-3">
					        <div className="widget-thumb widget-bg-color-white text-uppercase margin-bottom-20 bordered">
					            <h4 className="widget-thumb-heading">SHARPE</h4>
					            <div className="widget-thumb-wrap">
					                <i className="widget-thumb-icon bg-blue icon-bar-chart"></i>
					                <div className="widget-thumb-body">
					                    <span className="widget-thumb-subtitle">&nbsp;</span>
					                    <span className="widget-thumb-body-stat" data-counter="counterup" data-value={ this.state.widgetAlphas.sharpe }>0</span>
					                </div>
					            </div>
					        </div>
					    </div>
					</div>
				: null}

				<div className="row">
				    {/*this.state.blocks.main_chart_place ?
					    <div className="col-md-8">
					        <div className="portlet light bordered">
					            <div className="portlet-title">
					                <div className="caption">
					                    <i className="icon-cursor font-dark hide"></i>
					                    <span className="caption-subject font-dark bold uppercase">CHART</span>
					                </div>
					            </div>
					            <div className="portlet-body">
					                <div id="main_chart_place" style={{ width:'100%', height:'400px' }}></div>
					            </div>
					        </div>
					    </div>
				    : null }

				    {this.state.blocks.fund_benchmark_comparison_place ?
					    <div className="col-md-4">
					        <div className="portlet light bordered">
					            <div className="portlet-title">
					                <div className="caption">
					                    <i className="icon-cursor font-dark hide"></i>
					                    <span className="caption-subject font-dark bold uppercase">FUND AND BENCHMARK COMPARISON</span>
					                </div>
					            </div>
					            <div className="portlet-body">
					                <div id="fund_benchmark_comparison_place" style={{ width:'100%', height:'400px' }}></div>
					            </div>
					        </div>
					    </div>
					: null */}
				</div> 



				<div className="portlet light bordered">
					<div className="portlet-title">
						<div className="caption">
							<i className="icon-cursor font-dark hide"></i>
							<span className="caption-subject font-dark bold uppercase">Asset Class</span>
						</div>
					</div>
					<div className="portlet-body">
						<div id="asset_class_stock_place" style={{ width:'100%', height:'600px' }}></div>
					</div>
				</div>

				<div className="portlet light bordered">
					<div className="portlet-title">
						<div className="caption">
							<i className="icon-cursor font-dark hide"></i>
							<span className="caption-subject font-dark bold uppercase">Style</span>
						</div>
					</div>
					<div className="portlet-body">
						<div id="style_stock_place" style={{ width:'100%', height:'600px' }}></div>
					</div>
				</div>


				{/*this.state.blocks.conservative_fund_chart_place ?
					<div className="row">
					    <div className="col-md-6">
					        <div className="portlet light bordered">
					            <div className="portlet-title">
					                <div className="caption">
					                    <i className="icon-cursor font-dark hide"></i>
					                    <span className="caption-subject font-dark bold uppercase">CONSERVATIVE FUND AND BENCHMARK</span>
					                </div>
					            </div>
					            <div className="portlet-body">
					                <div id="conservative_fund_chart_place" style={{ width:'100%', height:'400px' }}></div>
					            </div>
					        </div>
					    </div>

					    <div className="col-md-6">
					        <div className="portlet light bordered">
					            <div className="portlet-title">
					                <div className="caption">
					                    <i className="icon-cursor font-dark hide"></i>
					                    <span className="caption-subject font-dark bold uppercase">CONSERVATIVE FUND RETURN</span>
					                </div>
					            </div>
					            <div className="portlet-body">
					                <div id="conservative_return_chart_place" style={{ width:'100%', height:'400px' }}></div>
					            </div>
					        </div>
					    </div>

					</div>
				: null */}


				<div className="portlet light bordered">
				    <div className="portlet-title">
				        <div className="caption">
				            <i className="icon-cursor font-dark hide"></i>
				            <span className="caption-subject font-dark bold uppercase">Rebalancing Dashboard</span>
				        </div>
				    </div>
				    <div className="portlet-body">
				        <div className="row">
				            <div className="col-md-12 col-sm-12 col-xs-12">
			                    <table className="table table-striped table-hover table-checkable order-column" id="last_portfolio_compare_table"></table>
				            </div>
				        </div>
				    </div>
				</div>

				<div className="portlet light bordered">
					<div className="portlet-title">
						<div className="caption">
							<i className="icon-cursor font-dark hide"></i>
							<span className="caption-subject font-dark bold uppercase">APPENDIX OF DISCLAIMERS</span>
						</div>
					</div>
					<div className="portlet-body disclaimer__container">
						<ul className="numeric__list">
							<li>The Model Portfolio was created with the assumption that the portfolio was rebalanced on the last business day of the quarter. Additionally, it assumes that all transactions (buys and sells) were made at the closing prices of the quarter.</li>
							<li>The Model Portfolio back tests were created using IQCIO proprietary algorithms. There is no guarantee that the actual portfolio will likely generate returns similar to those in the back test. Additionally, losses in the actual portfolio can exceed losses generated in the back test results.</li>
							<li>We reserve the right to enhance the models in an effort to improve performance. As and when those changes are implemented, the current back test results will no longer be relevant.</li>
							<li>The back test results do not take into account any cash flows. Any dividends paid out during the quarter are assumed to be reinvested at the beginning of the next quarter.</li>
							<li>The back test results assume an annual strategist fee of 30bps and an annual transaction fee of 15bps. The actual transaction fee incurred may be higher or lower. A client's actual performance may differ from that of the model portfolio returns if the client incurs any other expenses. Additional fees such as bank fees and financial advisor fees are not included in these back tests as they vary.</li>
							<li>The back tests assume that fees are collected after the close of end of the month. All transaction costs are assumed to incur at the time of rebalancing.</li>
							<li>There can be meaningful differences between simulated performance returns and the actual returns subsequently achieved by any particular trading program. Simulated trading does not involve financial risk, and no simulated trading record can completely account for the impact of financial risk in actual trading. For example, the decision to withstand losses or to adhere to a particular trading program in spite of trading losses are material points which can cause actual trading returns to deviate from simulated returns.</li>
							<li>There are a number of proprietary assumptions that models make in deciding allocations to securities such as security universe, volatility, correlations and other factors.</li>
							<li>There could be errors in data that the models received from third party sources. Any such errors could impact the output of the models and the subsequent performance numbers. IQCIO, LLC does not make any representation nor accuracy of data provided third party sources.</li>
							<li>The models and back tests do not seek to make tax efficient investments and do not take into account any tax implications. The model portfolios, and therefore the actual portfolios, can incur short term or long term gains/losses. Any investments that may be tax efficient are coincidental. IQCIO, LLC recommends investors to seek advice from their tax consultants.</li>
							<li>All information is provided “as is”, without any representations or warranties of any kind. IQCIO LLC expressly disclaims all express and implied warranties of these back tests including those with respect to accuracy, completeness, timeliness or fitness for a particular purpose. We assume no responsibility for any losses, whether direct, indirect, special or consequential, which arise out of the use of these back tests. Unless otherwise expressly indicated, all financial information is unaudited and there is no representation that financial information has been prepared in accordance with generally accepted accounting principles.</li>
							<li>Our mathematical algorithms generate model portfolios on a periodic basis, usually on a quarterly or monthly basis. For each time period when a model portfolio is generated, the algorithm seeks to optimize returns based on historical data that satisfies the risk limit of an annualized volatility of 10%, or lower, on an ex-ante basis. The annualized volatility of the actual returns can be different than the ex-ante annualized volatility of the model portfolio.</li>
						</ul>
						IQCIO, LLC. (”IQCIO") is a Registered Investment Adviser. This presentation and the information contained herein is not investment advice or a recommendation or solicitation to buy or sell any securities or funds. Advisory services are only offered to clients or prospective clients where IQCIO and its representatives are properly licensed or exempt from licensure. Past performance is no guarantee of future returns. Investing involves risk and possible loss of principal capital. The analyses and conclusions of IQCIO contained in this presentation are based on information by funds recommended by IQCIO. IQCIO is not responsible for inaccurate reporting by the funds. We recognize that there may be nonpublic information in the possession of the fund discussed in this presentation that could lead these funds and others to disagree with IQCIO’s analyses, conclusions and opinions. The analyses provided may include certain forward-looking statements, estimates and projections prepared with respect to, among other things, the historical and anticipated performance of the funds discussed in this presentation, market conditions and the values of assets and liabilities. Such statements, estimates, and projections reflect various assumptions by IQCIO concerning anticipated results that are inherently subject to significant economic, competitive, and other uncertainties and contingencies and have been included solely for illustrative purposes. No representations, express or implied, are made as to the accuracy or completeness of such statements, estimates or projections or with respect to any other materials herein and IQCIO disclaims any liability with respect thereto. Manager and investment due diligence process may not be completed as written in this presentation, depending on the client. It is possible that there will be developments in the future that cause IQCIO to change its position regarding these funds. IQCIO hereby disclaims any duty to provide any updates or changes to the analyses contained here including, without limitation, the manner or type of any IQCIO investment. Neither the information nor the opinions expressed herein should be used to make any investment decision without speak to your financial or other advisors.
					</div>
				</div>
			</div>
		)
	}
}

export default connect(
	state => ({}),
	dispatch => ({
		login: (login, password) => {
			dispatch({ type: 'LOGIN', payload: { login, password } })
		},
		loadStart: () => dispatch({ type: 'START_LOADING' }),
		loadStop: () => dispatch({ type: 'STOP_LOADING' }),
	})
)(Live)


// WEBPACK FOOTER //
// ./src/components/pages/Live.jsx